"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signInWithFBEmail = signInWithFBEmail;
exports.signOut = signOut;
exports.signUpWithFBEmail = signUpWithFBEmail;
exports.signInWithFBGoogle = signInWithFBGoogle;
exports.signInWithFacebook = signInWithFacebook;
exports.default = rootSaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _Auth = require("../constants/Auth");

var _Auth2 = require("../actions/Auth");

var _FirebaseService = _interopRequireDefault(require("../../services/FirebaseService"));

var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(signInWithFBEmail),
    _marked2 = /*#__PURE__*/_regeneratorRuntime2.mark(signOut),
    _marked3 = /*#__PURE__*/_regeneratorRuntime2.mark(signUpWithFBEmail),
    _marked4 = /*#__PURE__*/_regeneratorRuntime2.mark(signInWithFBGoogle),
    _marked5 = /*#__PURE__*/_regeneratorRuntime2.mark(signInWithFacebook),
    _marked6 = /*#__PURE__*/_regeneratorRuntime2.mark(rootSaga);

function signInWithFBEmail() {
  return _regenerator.default.wrap(function signInWithFBEmail$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_Auth.SIGNIN, /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
            var payload, email, password, user;
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    payload = _ref.payload;
                    email = payload.email, password = payload.password;
                    _context.prev = 2;
                    _context.next = 5;
                    return (0, _effects.call)(_FirebaseService.default.signInEmailRequest, email, password);

                  case 5:
                    user = _context.sent;

                    if (!user.message) {
                      _context.next = 11;
                      break;
                    }

                    _context.next = 9;
                    return (0, _effects.put)((0, _Auth2.showAuthMessage)(user.message));

                  case 9:
                    _context.next = 14;
                    break;

                  case 11:
                    localStorage.setItem(_Auth.AUTH_TOKEN, user.user.uid);
                    _context.next = 14;
                    return (0, _effects.put)((0, _Auth2.authenticated)(user.user.uid));

                  case 14:
                    _context.next = 20;
                    break;

                  case 16:
                    _context.prev = 16;
                    _context.t0 = _context["catch"](2);
                    _context.next = 20;
                    return (0, _effects.put)((0, _Auth2.showAuthMessage)(_context.t0));

                  case 20:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[2, 16]]);
          }));

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}

function signOut() {
  return _regenerator.default.wrap(function signOut$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeEvery)(_Auth.SIGNOUT, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
            var signOutUser;
            return _regenerator.default.wrap(function _callee2$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_FirebaseService.default.signOutRequest);

                  case 3:
                    signOutUser = _context3.sent;

                    if (!(signOutUser === undefined)) {
                      _context3.next = 10;
                      break;
                    }

                    localStorage.removeItem(_Auth.AUTH_TOKEN);
                    _context3.next = 8;
                    return (0, _effects.put)((0, _Auth2.signOutSuccess)(signOutUser));

                  case 8:
                    _context3.next = 12;
                    break;

                  case 10:
                    _context3.next = 12;
                    return (0, _effects.put)((0, _Auth2.showAuthMessage)(signOutUser.message));

                  case 12:
                    _context3.next = 18;
                    break;

                  case 14:
                    _context3.prev = 14;
                    _context3.t0 = _context3["catch"](0);
                    _context3.next = 18;
                    return (0, _effects.put)((0, _Auth2.showAuthMessage)(_context3.t0));

                  case 18:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee2, null, [[0, 14]]);
          }));

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked2);
}

function signUpWithFBEmail() {
  return _regenerator.default.wrap(function signUpWithFBEmail$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_Auth.SIGNUP, /*#__PURE__*/_regenerator.default.mark(function _callee3(_ref2) {
            var payload, email, password, user;
            return _regenerator.default.wrap(function _callee3$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    payload = _ref2.payload;
                    email = payload.email, password = payload.password;
                    _context5.prev = 2;
                    _context5.next = 5;
                    return (0, _effects.call)(_FirebaseService.default.signUpEmailRequest, email, password);

                  case 5:
                    user = _context5.sent;

                    if (!user.message) {
                      _context5.next = 11;
                      break;
                    }

                    _context5.next = 9;
                    return (0, _effects.put)((0, _Auth2.showAuthMessage)(user.message));

                  case 9:
                    _context5.next = 14;
                    break;

                  case 11:
                    localStorage.setItem(_Auth.AUTH_TOKEN, user.user.uid);
                    _context5.next = 14;
                    return (0, _effects.put)((0, _Auth2.signUpSuccess)(user.user.uid));

                  case 14:
                    _context5.next = 20;
                    break;

                  case 16:
                    _context5.prev = 16;
                    _context5.t0 = _context5["catch"](2);
                    _context5.next = 20;
                    return (0, _effects.put)((0, _Auth2.showAuthMessage)(_context5.t0));

                  case 20:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee3, null, [[2, 16]]);
          }));

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked3);
}

function signInWithFBGoogle() {
  return _regenerator.default.wrap(function signInWithFBGoogle$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeEvery)(_Auth.SIGNIN_WITH_GOOGLE, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
            var user;
            return _regenerator.default.wrap(function _callee4$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.prev = 0;
                    _context7.next = 3;
                    return (0, _effects.call)(_FirebaseService.default.signInGoogleRequest);

                  case 3:
                    user = _context7.sent;

                    if (!user.message) {
                      _context7.next = 9;
                      break;
                    }

                    _context7.next = 7;
                    return (0, _effects.put)((0, _Auth2.showAuthMessage)(user.message));

                  case 7:
                    _context7.next = 12;
                    break;

                  case 9:
                    localStorage.setItem(_Auth.AUTH_TOKEN, user.user.uid);
                    _context7.next = 12;
                    return (0, _effects.put)((0, _Auth2.signInWithGoogleAuthenticated)(user.user.uid));

                  case 12:
                    _context7.next = 18;
                    break;

                  case 14:
                    _context7.prev = 14;
                    _context7.t0 = _context7["catch"](0);
                    _context7.next = 18;
                    return (0, _effects.put)((0, _Auth2.showAuthMessage)(_context7.t0));

                  case 18:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee4, null, [[0, 14]]);
          }));

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked4);
}

function signInWithFacebook() {
  return _regenerator.default.wrap(function signInWithFacebook$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeEvery)(_Auth.SIGNIN_WITH_FACEBOOK, /*#__PURE__*/_regenerator.default.mark(function _callee5() {
            var user;
            return _regenerator.default.wrap(function _callee5$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.prev = 0;
                    _context9.next = 3;
                    return (0, _effects.call)(_FirebaseService.default.signInFacebookRequest);

                  case 3:
                    user = _context9.sent;

                    if (!user.message) {
                      _context9.next = 9;
                      break;
                    }

                    _context9.next = 7;
                    return (0, _effects.put)((0, _Auth2.showAuthMessage)(user.message));

                  case 7:
                    _context9.next = 12;
                    break;

                  case 9:
                    localStorage.setItem(_Auth.AUTH_TOKEN, user.user.uid);
                    _context9.next = 12;
                    return (0, _effects.put)((0, _Auth2.signInWithFacebookAuthenticated)(user.user.uid));

                  case 12:
                    _context9.next = 18;
                    break;

                  case 14:
                    _context9.prev = 14;
                    _context9.t0 = _context9["catch"](0);
                    _context9.next = 18;
                    return (0, _effects.put)((0, _Auth2.showAuthMessage)(_context9.t0));

                  case 18:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee5, null, [[0, 14]]);
          }));

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked5);
}

function rootSaga() {
  return _regenerator.default.wrap(function rootSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(signInWithFBEmail), (0, _effects.fork)(signOut), (0, _effects.fork)(signUpWithFBEmail), (0, _effects.fork)(signInWithFBGoogle), (0, _effects.fork)(signInWithFacebook)]);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked6);
}